import React, { FC, useContext, useEffect, useState } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";
import NotFound from "./pages/NotFound";

import { QueryStore } from "./App";
import { QueryNotRetainedErrorModal } from "./pages/ErrorModal";

// A guard to judge if clinic information has been saved in localStorage
// Unless retained, it would jump to error page
export const ClinicRetainedGuard = (props: any) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const clinicId = JSON.parse(localStorage.getItem("clinic") || "{}").id;
    if (!clinicId) {
      console.error("Clinic ID does not exist in localStorage");
      history.push("/error");
    }
  }, [history, location]);

  return <>{props.children}</>;
};

export const QueryRetainedGuard: FC<{ queryKeys: Array<string> }> = ({
  queryKeys,
  children,
}) => {
  const history = useHistory();
  const location = useLocation();

  const { query } = useContext(QueryStore);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);

  useEffect(() => {
    const keys = Object.keys(query);
    queryKeys.forEach((e) => {
      if (!keys.includes(e)) {
        console.error(`Query does not have key: ${e}`);
        setShowErrorModal(true);
      }
    });
  }, [history, location, query, queryKeys]);

  if (showErrorModal) {
    return (
      <>
        <QueryNotRetainedErrorModal></QueryNotRetainedErrorModal>
        {children}
      </>
    );
  }
  return <>{children}</>;
};

export const Router = () => {
  // TODO: Refactor guard to extract them to proper location
  return (
    <BrowserRouter>
      <Switch>
        {/* <Route exact path="/reservation_top/:clinic_id" component={ReservationTop}></Route>
                <Route exact path="/startup">
                    <ClinicRetainedGuard> <Startup /> </ClinicRetainedGuard>
                </Route>
                <Route exact path="/sms_authentication">
                    <ClinicRetainedGuard> <SMSAuthentication /> </ClinicRetainedGuard>
                </Route>

                <Route exact path="/input_query">
                    <ClinicRetainedGuard> <InputQuery /> </ClinicRetainedGuard>
                </Route>

                <Route exact path="/input_patient_detail">
                    <ClinicRetainedGuard>
                        <QueryRetainedGuard queryKeys={["selected"]} >
                            <InputPatientDetail></InputPatientDetail>
                        </QueryRetainedGuard>
                    </ClinicRetainedGuard>
                </Route>

                <Route exact path="/input_payment_method">
                    <ClinicRetainedGuard>
                        <QueryRetainedGuard queryKeys={[
                            "selected",
                            "first_name", "first_name_j", "last_name", "last_name_j",
                            "postal", "prefecture", "district",
                        ]} >
                            <InputPaymentMethod />
                        </QueryRetainedGuard>
                    </ClinicRetainedGuard>
                </Route>

                <Route exact path="/input_insurance_card">
                    <ClinicRetainedGuard>
                        <QueryRetainedGuard queryKeys={[
                            "selected",
                            "first_name", "first_name_j", "last_name", "last_name_j",
                            "postal", "prefecture", "district",
                            "payment_method"
                        ]} >
                            <InputInsuranceCard />
                        </QueryRetainedGuard>
                    </ClinicRetainedGuard>
                </Route>

                <Route exact path="/input_identity_document">
                    <ClinicRetainedGuard>
                        <QueryRetainedGuard queryKeys={[
                            "selected",
                            "first_name", "first_name_j", "last_name", "last_name_j",
                            "postal", "prefecture", "district",
                            "payment_method"
                        ]} >
                            <InputIdentityDocument />
                        </QueryRetainedGuard>
                    </ClinicRetainedGuard>
                </Route>

                <Route exact path="/confirm">
                    <ClinicRetainedGuard>
                        <QueryRetainedGuard queryKeys={[
                            "selected",
                            "first_name", "first_name_j", "last_name", "last_name_j",
                            "postal", "prefecture", "district",
                            "payment_method"
                        ]} >
                            <Confirm />
                        </QueryRetainedGuard>
                    </ClinicRetainedGuard>
                </Route>

                <Route exact path="/complete">
                    <ClinicRetainedGuard><Complete /></ClinicRetainedGuard>
                </Route>

                <Route exact path="/video_room/:token" component={VideoRoom}></Route>

                <Route exact path="/error" component={Error}></Route> */}

        <Route exact path="/404" component={NotFound}></Route>
        <Route component={NotFound}></Route>
      </Switch>
    </BrowserRouter>
  );
};
